import { TStatisticsPublicStoreState } from './types';

export function getPagesTable(state: TStatisticsPublicStoreState) {
  return state.pagesTable;
}

export function getSectionsTable(state: TStatisticsPublicStoreState) {
  return state.sectionsTable;
}

export function getViewsCountByTimeTable(state: TStatisticsPublicStoreState) {
  return state.viewsCountByTimeTable;
}

export function getVisitsCountByTimeTable(state: TStatisticsPublicStoreState) {
  return state.visitsCountByTimeTable;
}

export function getVisitsCountByTimeChartData(state: TStatisticsPublicStoreState) {
  return state.visitsCountByTimeChartData;
}

export function getViewsCountByTimeChartData(state: TStatisticsPublicStoreState) {
  return state.viewsCountByTimeChartData;
}
